// React imports
import PropTypes from 'prop-types';

//  material-ui imports
import { useTheme } from '@mui/material/styles';
import { Stack } from '@mui/material';

// ==============================|| FILEMNGR TOOLBAR ||============================== //

// eslint-disable-next-line arrow-body-style
const FileMngrToolbar = ({ children, bgcolor }) => {
    const theme = useTheme();
    const toolbarBgColor = bgcolor ?? (theme.palette.mode === 'dark' ? theme.palette.background.default : '#FAFAFA');
    return (
        <Stack
            sx={{
                [theme.breakpoints.down('md')]: {
                    display: 'flex',
                    overflowX: 'auto',
                    alignItems: 'center',
                    height: 43
                },
                [theme.breakpoints.up('md')]: {
                    display: 'flex',
                    flexWrap: 'wrap',
                    justifyContent: 'flex-start',
                    heigth: '43px auto'
                }
            }}
            pl={0.8}
            pr={1}
            direction="row"
            alignItems="center"
            bgcolor={toolbarBgColor}
        >
            {children}
        </Stack>
    );
};

FileMngrToolbar.propTypes = {
    children: PropTypes.node,
    bgcolor: PropTypes.string
};

export default FileMngrToolbar;
